import { render } from "./reviewTrust.vue?vue&type=template&id=19dd1c6e"
import script from "./reviewTrust.vue?vue&type=script&lang=js"
export * from "./reviewTrust.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__